'use client'
import { __awaiter } from '../../../../../../../_virtual/_tslib.js';
import { removeDialCode } from 'react-international-phone';
import { useTranslation } from 'react-i18next';
import { SmsVerificationError } from '@dynamic-labs/utils';
import { useCaptchaContext } from '../../../../../context/CaptchaContext/CaptchaContext.js';
import 'react';
import '../../../../../context/DynamicContext/DynamicContext.js';
import '../../../../../store/state/loadingAndLifecycle/loadingAndLifecycle.js';
import '@dynamic-labs/sdk-api-core';
import '../../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import { useViewContext } from '../../../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../../../utils/constants/colors.js';
import '../../../../../utils/constants/values.js';
import '../../../../../shared/consts/index.js';
import { dynamicEvents } from '../../../../../events/dynamicEvents.js';
import '../../../../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import { formatPhone } from '../../../../../utils/functions/formatPhone/formatPhone.js';
import '../../../../../store/state/nonce/nonce.js';
import '../../../../../store/state/projectSettings/projectSettings.js';
import '../../../../../config/ApiEndpoint.js';
import '../../../../../store/state/user/user.js';
import { createSmsVerification } from '../../../../../data/api/sms/sms.js';
import '../../../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../../../store/state/primaryWalletId/primaryWalletId.js';
import '../../../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../../../context/UserWalletsContext/UserWalletsContext.js';
import '../../../../../store/state/connectedWalletsInfo/connectedWalletsInfo.js';
import { useVerification } from '../../../../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../../../../utils/functions/compareChains/compareChains.js';
import '../../../../Passkey/utils/findPrimaryEmbeddedChain/findPrimaryEmbeddedChain.js';
import '../../../../../context/ThemeContext/ThemeContext.js';
import '../../../../../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import 'bs58';
import '@dynamic-labs/types';
import '../../../../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../../../../context/LoadingContext/LoadingContext.js';
import '../../../../../context/WalletContext/WalletContext.js';
import '../../../../../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import 'yup';
import '../../../../../context/MockContext/MockContext.js';
import { useFields } from '../../../../CollectUserDataView/useFields.js';
import '../../../../../context/FieldsStateContext/FieldsStateContext.js';
import '../../../../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../../../../store/state/walletOptions/walletOptions.js';
import '../../../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../../../../components/Alert/Alert.js';
import '../../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../../components/IconButton/IconButton.js';
import '../../../../../components/InlineWidget/InlineWidget.js';
import '../../../../../components/Input/Input.js';
import '../../../../../components/IsBrowser/IsBrowser.js';
import '../../../../../components/MenuList/Dropdown/Dropdown.js';
import '../../../../../components/OverlayCard/OverlayCard.js';
import '../../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../../../components/Popper/Popper/Popper.js';
import '../../../../../components/Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import 'formik';
import '../../../../../utils/hooks/useSubdomainCheck/useSubdomainCheck.js';
import '../../../../../context/WalletGroupContext/WalletGroupContext.js';
import '../../../../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../../../../context/ConnectWithOtpContext/ConnectWithOtpContext.js';
import '../../../../../context/ConnectWithOtpContext/constants.js';
import '../../../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '../../../../../locale/locale.js';
import { translation } from '../../../../../locale/en/translation.js';
import '@hcaptcha/react-hcaptcha';
import '../../../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../../../context/FooterAnimationContext/index.js';
import '../../../../../context/ErrorContext/hooks/useErrorText/useErrorText.js';
import '../../../../../context/PasskeyContext/PasskeyContext.js';
import '../../../../../store/state/sendBalances.js';
import '../../../../../store/state/connectorsInitializing/connectorsInitializing.js';
import '../../../../../components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import '../../../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import '../../../../TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../../../context/OnrampContext/OnrampContext.js';
import '../../../../../widgets/DynamicWidget/views/ReceiveWalletFunds/ReceiveWalletFunds.js';
import '../../../../../../index.js';
import '../../../../../store/state/tokenBalances.js';
import '../../../../../shared/utils/functions/getInitialUrl/getInitialUrl.js';
import { useInternalDynamicContext } from '../../../../../context/DynamicContext/useDynamicContext/useInternalDynamicContext/useInternalDynamicContext.js';

const useSubmitPhoneNumber = ({ onSubmit, onSubmitError, country, phone, setInvalidNumberMessage, }) => {
    const { engageCaptcha } = useCaptchaContext();
    const { view, pushView } = useViewContext();
    const { environmentId, projectSettings } = useInternalDynamicContext();
    const { setDisplayedDestination, setVerificationUUID, setRetryData } = useVerification();
    const { fieldsConfig } = useFields();
    const { t } = useTranslation();
    const submitPhoneNumber = (captchaToken) => __awaiter(void 0, void 0, void 0, function* () {
        if (!country)
            return;
        try {
            const phoneNumber = removeDialCode({
                dialCode: country.dialCode,
                phone,
            });
            const { verificationUUID } = yield createSmsVerification({
                captchaToken,
                environmentId,
                isoCountryCode: country.iso2,
                phoneCountryCode: country.dialCode,
                phoneNumber,
            });
            setRetryData({
                dialCode: country.dialCode,
                iso2: country.iso2,
                phone: phoneNumber,
            });
            // we can safely assume phone number always requires verification here
            // because this hook is only used for SMS sign in.
            pushView('login-with-sms-verification');
            setDisplayedDestination(formatPhone(phone));
            setVerificationUUID(verificationUUID);
            const phoneData = {
                dialCode: country.dialCode,
                iso2: country.iso2,
                phone: phoneNumber,
            };
            dynamicEvents.emit('authInit', {
                option: phoneData,
                phone: phoneData,
                type: 'sms',
            });
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
        catch (error) {
            pushView(view.type);
            if (error instanceof SmsVerificationError) {
                let message = t('dyn_login.helper.phone_number_form.invalid_phone');
                if (error.code === 'too_many_sms_verification_attempts') {
                    message = t('dyn_login.helper.phone_number_form.too_many_sms_verification_attempts');
                }
                // Use the code from error message if a translation for it exists
                if (error.code &&
                    error.code in translation.dyn_login.helper.phone_number_form)
                    message = t('dyn_login.helper.phone_number_form.' + error.code);
                setInvalidNumberMessage(message);
            }
            else if (typeof error === 'string')
                setInvalidNumberMessage(error);
            onSubmitError === null || onSubmitError === void 0 ? void 0 : onSubmitError();
        }
    });
    return (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!country)
            return;
        event.preventDefault();
        try {
            fieldsConfig.phoneNumber.validation.validateSync(phone);
        }
        catch (error) {
            const { message } = error;
            setInvalidNumberMessage(message);
            onSubmitError === null || onSubmitError === void 0 ? void 0 : onSubmitError();
            return;
        }
        if ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _a === void 0 ? void 0 : _a.enabled) {
            engageCaptcha({
                authMethod: 'phone',
                onCaptchaSuccess: submitPhoneNumber,
            });
            return;
        }
        submitPhoneNumber();
    });
};

export { useSubmitPhoneNumber };
